import Axios from "axios";

const RESOURCE = "/api/mail";

export default {
  /**
   * Send email after theme is shared in admin
   * Admin only
   */
  sendThemeSharedEmail(payload) {
    return Axios.post(`${RESOURCE}/handleSendSharedThemeEmail`, payload);
  },

  sendWelcomeEmailFromSharedVideo(payload) {
    return Axios.post(`${RESOURCE}/handleSendWelcomeEmailFromSharedVideo`, payload);
  },

  sendWelcomeEmailFromSharedTheme(payload) {
    return Axios.post(`${RESOURCE}/handleSendWelcomeEmailFromSharedTheme`, payload);
  },

  sendSharedVideoEmail(payload) {
    return Axios.post(`${RESOURCE}/handleSendSharedVideoEmail`, payload);
  }
};
